import { render } from "./RequestChangePass.vue?vue&type=template&id=0e7a5e76&scoped=true&lang=pug"
import script from "./RequestChangePass.vue?vue&type=script&lang=js"
export * from "./RequestChangePass.vue?vue&type=script&lang=js"

import "./RequestChangePass.vue?vue&type=style&index=0&id=0e7a5e76&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a5e76"]])

export default __exports__